import { render, staticRenderFns } from "./rooms.vue?vue&type=template&id=c7a88206&scoped=true&"
import script from "./rooms.vue?vue&type=script&lang=js&"
export * from "./rooms.vue?vue&type=script&lang=js&"
import style0 from "./rooms.vue?vue&type=style&index=0&id=c7a88206&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a88206",
  null
  
)

export default component.exports